import { render, staticRenderFns } from "./ValueRangeConfig.vue?vue&type=template&id=68614dd7&scoped=true"
import script from "./ValueRangeConfig.vue?vue&type=script&lang=js"
export * from "./ValueRangeConfig.vue?vue&type=script&lang=js"
import style0 from "./ValueRangeConfig.vue?vue&type=style&index=0&id=68614dd7&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68614dd7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68614dd7')) {
      api.createRecord('68614dd7', component.options)
    } else {
      api.reload('68614dd7', component.options)
    }
    module.hot.accept("./ValueRangeConfig.vue?vue&type=template&id=68614dd7&scoped=true", function () {
      api.rerender('68614dd7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/attributes/modules/use_cases/components/ValueRangeConfig.vue"
export default component.exports